// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"596":"1a555ef6","1297":"4cfd0d6f","2831":"97fcf5cb","5808":"93e77de2"}[chunkId] + ".chunk.css";
};